const washAndFoldWomen = [
	{
		id: '2201',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Top Wear (Shirt / T-shirt / Fatua)',
		category: "Women's wear",
		service: 'Wash And Fold',
		price: 45,
		quantity: 1
    },
    
	{
		id: '2202',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Bottom Wear (Trouser / Slack / Pazama)',
		category: "Women's wear",
		service: 'Wash And Fold',
		price: 45,
		quantity: 1
    },
    
	{
		id: '2203',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Accessories (Scarf / Dupatta / Orna / Muffler)',
		category: "Women's wear",
		service: 'Wash And Fold',
		price: 45,
		quantity: 1
    },
    
	{
		id: '2204',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Winter Wear (Sweater / Cardigan)',
		category: "Women's wear",
		service: 'Wash And Fold',
		price: 85,
		quantity: 1
    },
    
	{
		id: '2205',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Home Wear (Nightdress / Normal Maxi)',
		category: "Women's wear",
		service: 'Wash And Fold',
		price: 45,
		quantity: 1
    },
    
	{
		id: '2206',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Long Dress(Borka / Jumpsuit / Arabian Dress)',
		category: "Women's wear",
		service: 'Wash And Fold',
		price: 60,
		quantity: 1
    },
    
	{
		id: '2207',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Inner Wear (Blous / Petticoat / Under Garments)',
		category: "Women's wear",
		service: 'Wash And Fold',
		price: 45,
		quantity: 1
    },
    
	{
		id: '2208',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Saree (Plain Cotton / Plain Silk / Cotton Design)',
		category: "Women's wear",
		service: 'Wash And Fold',
		price: 125,
		quantity: 1
    },
    
	{
		id: '2209',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Saree - Exclusive (Benarasi / Jamdani / Katan)',
		category: "Women's wear",
		service: 'Wash And Fold',
		price: 200,
		quantity: 1
    },
    
	{
		id: '2210',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Kameez / Kaftan / Apron / Tops',
		category: "Women's wear",
		service: 'Wash And Fold',
		price: 45,
		quantity: 1
    },
    
	{
		id: '2211',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Exclusive Kameez',
		category: "Women's wear",
		service: 'Wash And Fold',
		price: 80,
		quantity: 1
    },
    
	{
		id: '2212',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Waist Coat / Coati',
		category: "Women's wear",
		service: 'Wash And Fold',
		price: 60,
		quantity: 1
    },
    
	{
		id: '2213',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Skirt',
		category: "Women's wear",
		service: 'Wash And Fold',
		price: 80,
		quantity: 1
    },
    
	{
		id: '2214',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Kameez',
		category: "Women's wear",
		service: 'Wash And Fold',
		price: 130,
		quantity: 1
    },
    
	{
		id: '2215',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Dress / Gown',
		category: "Women's wear",
		service: 'Wash And Fold',
		price: 250,
		quantity: 1
    },
    
	{
		id: '2216',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Skirt Suit',
		category: "Women's wear",
		service: 'Wash And Fold',
		price: 200,
		quantity: 1
    },
    
	{
		id: '2217',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Shawl',
		category: "Women's wear",
		service: 'Wash And Fold',
		price: 100,
		quantity: 1
    },
    
	{
		id: '2218',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Blazer / Coat / Jacket',
		category: "Women's wear",
		service: 'Wash And Fold',
		price: 100,
		quantity: 1
    },
    
	{
		id: '2219',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Leather Jacket',
		category: "Women's wear",
		service: 'Wash And Fold',
		price: 450,
		quantity: 1
    },
    
	{
		id: '2220',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Overcoat',
		category: "Women's wear",
		service: 'Wash And Fold',
		price: 300,
		quantity: 1
	}
];
export default washAndFoldWomen;
